<template>
  <div class="CurriculumVideo sw-container">
    <div class="common-nav">
      <span class="s1">您的位置</span>
      <span class="s2">|</span>
      <span class="s1">选课中心</span>
      <span class="s2">|</span>
      <span class="s3">观看</span>
    </div>
    <div class="CurriculumVideo-top">
      <div class="CurriculumVideo-top-l">
        <div class="CurriculumVideo-title">
          {{ dataInfo[pageIndex].name }}({{ dataInfo[pageIndex].type }})
        </div>
        <div class="CurriculumVideo-browse">
          已有{{ dataInfo[pageIndex].studyNum }}人学习
        </div>
      </div>
<!--      <div class="CurriculumVideo-back" @click="setNoTime()" style="margin-right: 200px">不计时模式</div>-->
      <div class="CurriculumVideo-back" @click="back">返回</div>
    </div>
    <div class="CurriculumVideo-main">
      <div id="playerContainer">
        <remote-js
            src="https://p.bokecc.com/player?siteid=2661F9756E5C832E&newversion=true"
        ></remote-js>
      </div>
      <div class="CurriculumVideo-list">
        <div class="CurriculumVideo-user">
          <img
              class="CurriculumVideo-user-img"
              :src="
              dataInfo[pageIndex].teacherSrc ||
                require('../../assets/img/loginImg.png')
            "
          />
          <div class="CurriculumVideo-user-r">
            <div class="CurriculumVideo-user-position">授课教师</div>
            <div class="CurriculumVideo-user-name">
              {{ dataInfo[pageIndex].teacherName }}
            </div>
          </div>
        </div>
        <Tabs value="name1">
          <TabPane label="目录" name="name1">
            <div class="CurriculumVideo-catalog">
              <Timeline>
                <template v-for="(i, index) in dataInfo">
                  <TimelineItem
                      v-if="i.hasStudy == 1 && index != pageIndex"
                      class="CurriculumVideo-future"
                      @click.native="read(index)"
                  >{{ i.name }}
                  </TimelineItem
                  >
                  <TimelineItem
                      v-if="index == pageIndex"
                      class="CurriculumVideo-now"
                      @click.native="read(index)"
                  >{{ i.name }}
                  </TimelineItem
                  >
                  <TimelineItem
                      v-if="i.hasStudy == 0 && index != pageIndex"
                      @click.native="read(index)"
                  >{{ i.name }}
                  </TimelineItem
                  >
                </template>
              </Timeline>
            </div>
          </TabPane>
          <TabPane label="提问" name="name2" v-if="master">
            <div class="CurriculumVideo-questions">
              <Input
                  v-model="wen"
                  maxlength="100"
                  show-word-limit
                  type="textarea"
                  placeholder="您有什么问题呢"
              />
              <div class="CurriculumVideo-questions-btn" @click="submit">
                确认
              </div>
            </div>
          </TabPane>
        </Tabs>

        <div
            class="CurriculumVideo-time"
            v-if="master && !$route.query.shiting"
        >
          <div class="CurriculumVideo-time-l">
            <div class="CurriculumVideo-time-font" v-if="timeData.zytime">
              专业所需课学时
              <span class="s1">
                <span class="s2">{{ timeData.zyStudyTime | decimal }}</span>
                /{{ timeData.zytime | decimal }}
              </span>
            </div>
            <div class="CurriculumVideo-time-font" v-if="timeData.gxtime">
              公需所需课学时
              <span class="s1">
                <span class="s3">{{ timeData.gxStudyTime | decimal }}</span>
                /{{ timeData.gxtime | decimal }}
              </span>
            </div>
          </div>
          <!--          <div-->
          <!--            class="CurriculumVideo-time-btn"-->
          <!--            @click="handleTest"-->
          <!--            :class="{-->
          <!--              'CurriculumVideo-active':-->
          <!--                timeData.gxStudyTime>=timeData.gxtime && timeData.zyStudyTime >= 0,-->
          <!--            }"-->
          <!--          >-->
          <!--            去考试-->
          <!--            &lt;!&ndash; 考试 {{ timeData.examTimes }}次 &ndash;&gt;-->
          <!--          </div>-->
        </div>
      </div>
    </div>
    <div class="CurriculumVideo-mask" v-if="maskFlag"></div>
    <div class="CurriculumVideo-alert" v-if="maskFlag">
      <div class="CurriculumVideo-alert-title">
        <span class="s1">防挂机操作</span>
        <span class="s2">
          <span class="s3">{{ countdown }}</span
          >由于长时间未作答，系统监测你有挂机嫌疑！
        </span>
      </div>
      <div style="padding-bottom:32px;">
        <div class="CurriculumVideo-subject">{{ qData.title }}</div>
        <template v-if="qData.type == '单选'">
          <div
              class="CurriculumVideo-answer"
              :class="{ 'CurriculumVideo-answer-active': active == 'a' }"
              @click="active = 'a'"
          >
            <span>A</span>
            <p>{{ qData.ansa }}</p>
          </div>
          <div
              class="CurriculumVideo-answer"
              :class="{ 'CurriculumVideo-answer-active': active == 'b' }"
              @click="active = 'b'"
          >
            <span>B</span>
            <p>{{ qData.ansb }}</p>
          </div>
          <div
              class="CurriculumVideo-answer"
              :class="{ 'CurriculumVideo-answer-active': active == 'c' }"
              @click="active = 'c'"
          >
            <span>C</span>
            <p>{{ qData.ansc }}</p>
          </div>
          <div
              class="CurriculumVideo-answer"
              :class="{ 'CurriculumVideo-answer-active': active == 'd' }"
              @click="active = 'd'"
          >
            <span>D</span>
            <p>{{ qData.ansd }}</p>
          </div>
        </template>
        <template v-if="qData.type == '多选'">
          <div
              class="CurriculumVideo-answer"
              :class="{
              'CurriculumVideo-answer-active': active.indexOf('a') >= 0,
            }"
              @click="selection('a')"
          >
            <span>A</span>
            <p>{{ qData.ansa }}</p>
          </div>
          <div
              class="CurriculumVideo-answer"
              :class="{
              'CurriculumVideo-answer-active': active.indexOf('b') >= 0,
            }"
              @click="selection('b')"
          >
            <span>B</span>
            <p>{{ qData.ansb }}</p>
          </div>
          <div
              class="CurriculumVideo-answer"
              :class="{
              'CurriculumVideo-answer-active': active.indexOf('c') >= 0,
            }"
              @click="selection('c')"
          >
            <span>C</span>
            <p>{{ qData.ansc }}</p>
          </div>
          <div
              class="CurriculumVideo-answer"
              :class="{
              'CurriculumVideo-answer-active': active.indexOf('d') >= 0,
            }"
              @click="selection('d')"
          >
            <span>D</span>
            <p>{{ qData.ansd }}</p>
          </div>
        </template>
        <template v-if="qData.type == '判断'">
          <div
              class="CurriculumVideo-answer"
              :class="{ 'CurriculumVideo-answer-active': active == 'a' }"
              @click="active = 'a'"
          >
            <span>A</span>
            <p>正确</p>
          </div>
          <div
              class="CurriculumVideo-answer"
              :class="{ 'CurriculumVideo-answer-active': active == 'b' }"
              @click="active = 'b'"
          >
            <span>B</span>
            <p>错误</p>
          </div>
        </template>
        <div class="CurriculumVideo-answer-btn" @click="answer">提交</div>
        <div class="CurriculumVideo-answer-msg">选择错误，请重新选择！</div>
      </div>
      <!--<div class="CurriculumVideo-alert-bottom">
				<Input v-model="value" placeholder="请输入手机短信验证码" />
				<div class="CurriculumVideo-alert-bar">
					<span class="CurriculumVideo-alert-btn2" @click="getCodeFn">{{codeTest}}</span>
					<div class="CurriculumVideo-alert-btn" @click="postCode">确认</div>
				</div>
      </div>-->
    </div>
    <div class="CurriculumVideo-alert2" v-if="false">
      试听结束，赶紧去购买套餐
    </div>
    <Modal
        v-model="msgFlag"
        width="420"
        :closable="false"
        :mask-closable="false"
    >
      <p slot="header">提示</p>
      <div style="text-align:center;font-size: 18px;">
        系统检测您是否挂机,请点击确定继续学习
      </div>
      <div slot="footer">
        <Button size="large" @click="msgOk">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import * as api from "@/assets/api/api.js";

let moment = require("moment");
export default {
  name: "CurriculumVideo",
  components: {
    "remote-js": {
      render(createElement) {
        return createElement("script", {
          attrs: {
            type: "text/javascript",
            src: this.src,
          },
        });
      },
      props: {
        src: {
          type: String,
          required: true,
        },
      },
    },
  },
  data() {
    return {
      notime:false,
      msgFlag: false,
      wen: "",
      value: "",
      maskFlag: false,
      countdown: "03:00",
      codeTest: "重新发送",
      codeFlag: true,
      timer: null,
      showFlag: true,
      pageIndex: 0,
      dataInfo: [
        {
          name: "",
          teacherName: "",
        },
      ],
      playerNew: "",
      active: "",
      qData: {},
      checkTime: 10,
      tTimer: null,
      timer1: null,
      timeNum: 1,
      comboId: "",
      shiting: false,
    };
  },
  created() {
    this.comboId = this.$route.query.id; //页面销毁时用
    this.shiting = this.$route.query.shiting;
    //			this.patrol()
    //文档			https://doc.bokecc.com/vod/developer/H5/%E7%9B%B8%E5%85%B3api.html
    let that = this;
    this.getData();
    window.on_CCH5player_play = function (video, vid) {
      console.info("我播放了",that.dataInfo[that.pageIndex].id);
      if (!that.tTimer) {
        that.tTimer = setInterval(() => {
          if (
              Math.floor(that.playerNew.getPosition()) ==
              that.checkTime * that.timeNum * 60
          ) {
            that.getQuestion();
            clearInterval(that.tTimer);
            that.tTimer = null;
          }
        }, 1000);
      }
    };
    window.on_CCH5player_pause = function (obj) {
      console.info("我暂停了");
      if (that.tTimer) {
        clearInterval(that.tTimer);
        that.tTimer = null;
      }
    };
    window.on_CCH5player_ended = function (obj) {
      if (that.master && !that.$route.query.shiting) {
        if (that.timeFormat(that.playerNew.getPosition()) == "000000") {
          return;
        }
        api
            .postData(
                "student/saveRecord",
                {
                  comboId: that.$route.query.id,
                  coursewareId: that.dataInfo[that.pageIndex].id,
                  schedule: that.timeFormat(that.playerNew.getPosition()),
                  videoTimer: that.timeFormat(that.playerNew.getDuration()),
                },
                (err) => {
                  console.log(err);
                }
            )
            .then((res) => {
              // api.EventBus.$emit("loadTimeInfo");
              //刷新列表状态
              // if (that.shiting) {
              //   api
              //     .postData("subject/getCourseListsNoLogin", {
              //       // specialId: that.$route.query.specialId
              //     })
              //     .then(res => {
              //       that.dataInfo = res.data;
              //     });
              // } else {
              //   api
              //     .postData("subject/getCourseLists", {
              //       comboId: this.$route.query.id,
              //       specialId: that.$route.query.specialId
              //     })
              //     .then(res => {
              //       that.dataInfo = res.data;
              //     });
              // }
              that.loadTimerData();
              if (that.pageIndex == that.dataInfo.length - 1) {
                clearInterval(that.timer1);
                that.$Notice.success({
                  title: "提示",
                  desc: "恭喜您学完本课程",
                });
                return;
              }
              // that.pageIndex++;
              that.playerNew = createCCH5Player({
                vid: that.dataInfo[that.pageIndex].vid,
                siteid: that.getSiteid(that.dataInfo[that.pageIndex].siteid, that.dataInfo[that.pageIndex].updatetime),
                customerId: 'jxjy2_' + this.$store.state.master.user.id,
                mediatype: 1,
                autoStart: "true",
                width: 880,
                height: 495,
                isShare: "false",
                banDrag: "false",
                progressbar_enable: 0,
                watchStartTime: this.convertTimeToSeconds(this.dataInfo[that.pageIndex].schedule),
                parentNode: "#playerContainer",
              });

              clearInterval(that.timer1);

              that.saveTimeRecord();
            });
      } else {
        if (that.pageIndex == that.dataInfo.length - 1) {
          that.$Notice.success({
            title: "提示",
            desc: "恭喜您学完本课程",
          });
          return;
        }
        that.pageIndex++;
        that.playerNew = createCCH5Player({
          vid: that.dataInfo[that.pageIndex].vid,
          siteid: that.getSiteid(that.dataInfo[that.pageIndex].siteid, that.dataInfo[that.pageIndex].updatetime),
          customerId: 'jxjy2_' + this.$store.state.master.user.id,
          mediatype: 1,
          autoStart: "true",
          width: 880,
          height: 495,
          isShare: "false",
          banDrag: "false",
          progressbar_enable: 0,
          watchStartTime: this.convertTimeToSeconds(this.dataInfo[that.pageIndex].schedule),
          parentNode: "#playerContainer",
        });
      }
    };
    console.info("master", this.master, this.$route.query.shiting);

    if (this.master) {
      if (this.$route.query.id) {
        this.loadTimerData();
      }

      //判断路由是否带试听参数，如果有则不触发防作弊
      if (eval(this.$route.query.shiting)) {
      } else {
        this.getQuestionTime();
      }
    }
  },
  filters: {
    decimal(val) {
      return Number(val).toFixed(2);
    },
  },
  computed: {
    ...mapState(["timeData"]),
    // really() {
    //   if (this.timeData.zytime && this.timeData.gxtime) {
    //     if (
    //       this.timeData.zyStudyTime < this.timeData.zytime ||
    //       this.timeData.gxStudyTime < this.timeData.gxtime
    //     ) {
    //       return false;
    //     }
    //   } else {
    //     //判断专业课
    //     if (this.timeData.zytime) {
    //       if (this.timeData.zyStudyTime < this.timeData.zytime) {
    //         return false;
    //       }
    //     }
    //     //判断公需课
    //     if (this.timeData.gxtime) {
    //       if (this.timeData.gxStudyTime < this.timeData.gxtime) {
    //         return false;
    //       }
    //     }
    //   }
    //   return true;
    // },
    master() {
      return this.$store.state.master.token.token;
    },
  },
  mounted() {
  },
  methods: {
    ...mapActions(["getTimeData"]),
    // 判断siteid：2026-06-01之前使用 dataInfo中的siteid，之后固定使用0631688005957135
    getSiteid(siteid, updatetime) {
      if (new Date(updatetime) < new Date("2026-06-01")) {
        return siteid;
      }
      return "0631688005957135";
    },
    loadTimerData() {
      this.$nextTick(() => {
        this.getTimeData({
          id: this.$route.query.id,
        });
      });
    },
    answer() {
      if (!this.active) {
        this.$Message.warning("请作答");
        return;
      }
      if (this.qData.type == "单选") {
        // if (this.active == this.qData.answer) {
        // this.$Message.success("答题正确,请继续学习");
        this.$Message.success("请继续学习");
        this.maskFlag = false;
        clearInterval(this.timer);
        this.playerNew.play();
        this.timeNum++;
        this.tTimer = setInterval(() => {
          if (
              Math.floor(this.playerNew.getPosition()) ==
              this.checkTime * this.timeNum * 60
          ) {
            this.getQuestion();
            clearInterval(this.tTimer);
            this.tTimer = null;
          }
        }, 1000);
        // } else {
        //   this.$Message.success("请继续学习");
        //   this.maskFlag = false;
        //   // this.$Message.warning("答案错误,请重新选择");
        // }
      }
      if (this.qData.type == "多选") {
        // if (this.qData.answer.indexOf(this.active) > -1) {
        this.$Message.success("请继续学习");
        // this.$Message.success("答题正确,请继续学习");
        this.maskFlag = false;
        clearInterval(this.timer);
        this.playerNew.play();
        this.timeNum++;
        this.tTimer = setInterval(() => {
          if (
              Math.floor(this.playerNew.getPosition()) ==
              this.checkTime * this.timeNum * 60
          ) {
            this.getQuestion();
            clearInterval(this.tTimer);
            this.tTimer = null;
          }
        }, 1000);
        // } else {
        //   this.$Message.success("请继续学习");
        //   this.maskFlag = false;
        //   // this.$Message.warning("答案错误,请重新选择");
        // }
      }
      if (this.qData.type == "判断") {
        let btn = this.active == "a" ? "正确" : "错误";
        // if (btn == this.qData.answer) {
        this.$Message.success("请继续学习");
        // this.$Message.success("答题正确,请继续学习");
        this.maskFlag = false;
        clearInterval(this.timer);
        this.playerNew.play();
        this.timeNum++;
        this.tTimer = setInterval(() => {
          if (
              Math.floor(this.playerNew.getPosition()) ==
              this.checkTime * this.timeNum * 60
          ) {
            this.getQuestion();
            clearInterval(this.tTimer);
            this.tTimer = null;
          }
        }, 1000);
        // } else {
        //   this.$Message.success("请继续学习");
        //   this.maskFlag = false;
        //   // this.$Message.warning("答案错误,请重新选择");
        // }
      }
    },
    msgOk() {
      this.msgFlag = false;
      this.timeNum++;
      this.playerNew.play();
    },
    handleTest() {
      if (!(timeData.gxStudyTime >= timeData.gxtime && timeData.zyStudyTime >= 0)) {
        this.$Message.warning("完成所需学时才能参加考试");
        return;
      }
      if (this.timeData.examTimesLeft == 0) {
        this.$Message.warning("已经没有考试机会");
        return;
      }
      // this.$router.push({
      //    path: "/ExaminationInfo",
      //    query: {
      //      cid: this.$route.query.cid,
      //      orderId: this.$route.query.oid,
      //      id: this.$route.query.id,
      //    },
      //  });
      // if (this.timeData.examTimes <= 0) {
      //   this.$router.push({
      //     path: "/ExaminationIdentity",
      //     query: {
      //       cid: this.$route.query.cid,
      //       orderId: this.$route.query.oid,
      //       id: this.$route.query.id,
      //     },
      //   });
      // } else {
      //   this.$router.push({
      //     path: "/ExaminationInfo",
      //     query: {
      //       cid: this.$route.query.cid,
      //       orderId: this.$route.query.oid,
      //       id: this.$route.query.id,
      //     },
      //   });
      // }
    },
    getQuestionTime() {
      api.postData("exam/getQuestionTime", {}).then((res) => {
        this.checkTime = res.data.timer;
      });
    },
    getQuestion() {
      if (this.shiting) return;
      api
          .postData("exam/getQuestion", {
            specialId: this.$route.query.specialId,
          })
          .then((res) => {
            this.playerNew.pause();
            this.patrol();
            this.active = "";
            this.qData = res.data;
            if (this.qData.type == "多选") {
              this.active = [];
            } else {
              this.active = "";
            }
          })
          .catch((res) => {
            console.info("错误啦", res);
            if (this.$store.state.master.token.token) {
              if (res.message == "该专题下没有相关考题") {
                this.msgFlag = true;
                this.playerNew.pause();
              }
            }
          });
    },
    // getTimer() {
    //   api
    //     .postData("studentCenter/getTimer", {
    //       comboId: this.$route.query.cid,
    //     })
    //     .then((res) => {
    //       this.$nextTick(() => {
    //         for (let i of res.data) {
    //           if (i.type == "专业课") {
    //             this.zStudyTime = i.studyTime;
    //             this.zExamTime = i.examTime;
    //           }
    //           if (i.type == "公需课") {
    //             this.gStudyTime = i.studyTime;
    //             this.gExamTime = i.examTime;
    //           }
    //         }
    //       });
    //     });
    // },
    saveTimeRecord() {
      this.timer1 = setInterval(() => {
        if (this.timeFormat(this.playerNew.getPosition()) == "000000") {
          return;
        }
        if (this.$route.query.shiting) {
          return;
        }
        api
            .postData(
                "student/saveRecord",
                {
                  comboId: this.$route.query.id,
                  coursewareId: this.dataInfo[this.pageIndex].id,
                  schedule: this.timeFormat(this.playerNew.getPosition()),
                  videoTimer: this.timeFormat(this.playerNew.getDuration()),
                },
                (err) => {
                  console.log(err);
                }
            )
            .then((res) => {
              this.loadTimerData();
            });
      }, 60000);
    },
    getData() {
      api.showLoading();
      if (this.shiting) {
        api
            .postData("subject/getCourseListsNoLogin", {
              specialId: this.$route.query.specialId,
            })
            .then((res) => {
              this.dataInfo = res.data;
              if (res.data.length <= 0) {
                this.$Message.warning("暂无试听课程");
                setTimeout(() => {
                  this.$router.back();
                }, 2000);
                return;
              }
              for (let i = 0; i < res.data.length; i++) {
                if (res.data[i].hasStudy == 0) {
                  this.pageIndex = i;
                  break;
                }
              }
              setTimeout(() => {
                let playerNew = createCCH5Player({
                  vid: res.data[this.pageIndex].vid,
                  siteid: this.getSiteid(res.data[this.pageIndex].siteid, res.data[this.pageIndex].updatetime),
                  customerId: 'jxjy2_' + this.$store.state.master.user.id,
                  mediatype: 1,
                  autoStart: "true",
                  width: 880,
                  height: 495,
                  isShare: "false",
                  banDrag: "false",
                  progressbar_enable: 0,
                  watchStartTime: this.convertTimeToSeconds(this.dataInfo[this.pageIndex].schedule),
                  parentNode: "#playerContainer",
                });
                this.playerNew = playerNew;
              }, 500);
            });
      } else {
        api
            .postData("subject/getCourseLists", {
              comboId: this.$route.query.id,
              specialId: this.$route.query.specialId,
            })
            .then((res) => {
              this.dataInfo = res.data;
              if (this.$route.query.shiting) {
                if (res.data.length <= 0) {
                  this.$Message.warning("暂无试听课程");
                  setTimeout(() => {
                    this.$router.back();
                  }, 2000);
                  return;
                }
              }
              //设置后台获取到的学习进度
              for (let i = 0; i < res.data.length; i++) {
                localStorage.setItem(res.data[i].vid, res.data[i].scheduleSec)
              }
              for (let i = 0; i < res.data.length; i++) {
                if (res.data[i].hasStudy == 0) {
                  this.pageIndex = i;
                  break;
                }
              }

              //2026 6月一号之前使用 res.data[this.pageIndex].siteid 年以后使用0631688005957135
              //已改为通过 getSiteid(siteid, updatetime) 方法根据 updatetime 判断

              setTimeout(() => {
                let playerNew = createCCH5Player({
                  vid: res.data[this.pageIndex].vid,
                  siteid: this.getSiteid(res.data[this.pageIndex].siteid, res.data[this.pageIndex].updatetime),
                  customerId: 'jxjy2_' + this.$store.state.master.user.id,
                  mediatype: 1,
                  autoStart: "true",
                  width: 880,
                  height: 495,
                  isShare: "false",
                  banDrag: "false",
                  progressbar_enable: 0,
                  watchStartTime: this.convertTimeToSeconds(this.dataInfo[this.pageIndex].schedule),
                  parentNode: "#playerContainer",
                });
                this.playerNew = playerNew;

                this.tTimer = setInterval(() => {
                  // console.info(
                  //   Math.floor(playerNew.getPosition()),
                  //   this.checkTime * 60
                  // );
                  if (
                      Math.floor(playerNew.getPosition()) ==
                      this.checkTime * this.timeNum * 60
                  ) {
                    this.getQuestion();
                    clearInterval(this.tTimer);
                    this.tTimer = null;
                  }
                }, 1000);
                this.saveTimeRecord();
              }, 500);
            });
      }
    },

    patrol() {
      this.maskFlag = true;
      let num = 180;
      this.timer = setInterval(() => {
        num--;
        this.countdown = `0${Math.floor(num / 60)}:${
            num % 60 < 10 ? "0" + (num % 60) : num % 60
        }`;
        if (num == 0) {
          //没有完成验证
          clearInterval(this.timer);
          this.$Notice.error({
            title: "提示",
            desc: "您挂机了",
            duration: 3600,
          });
          this.back();
        }
      }, 1000);
      //				this.getCodeFn();
    },
    getCodeFn() {
      if (!this.codeFlag) {
        return;
      }
      this.codeFlag = false;
      this.getCode();
      let num = 60;
      let timer = setInterval(() => {
        num--;
        this.codeTest = num + "s";
        if (num == 0) {
          //没有完成验证
          clearInterval(timer);
          this.codeTest = "重新发送";
          this.codeFlag = true;
        }
      }, 1000);
    },
    getCode() {
      api
          .postData("student/sendSmsCode", {
            phone: this.$store.state.master.user.phone,
          })
          .then((res) => {
          });
    },
    submit() {
      if (this.wen.length < 10) {
        this.$Message.error("问题至少有10个字嘛");
        return;
      }
      api
          .postData("message/saveMessage", {
            content: this.wen,
            coursewareId: this.dataInfo[this.pageIndex].id,
          })
          .then((res) => {
            this.$Message.success("问题提交成功");
            this.wen = "";
          });
    },
    postCode() {
      api
          .postData("student/checkSmsCode", {
            phone: this.$store.state.master.user.phone,
            vercode: this.value,
          })
          .then((res) => {
            this.$Message.success("验证成功");
            clearInterval(this.timer);
            this.maskFlag = false;
          });
    },
    timeFormat(time) {
      let s =
          Math.floor(time / 3600) < 10
              ? "0" + Math.floor(time / 3600)
              : Math.floor(time / 3600);
      let f =
          Math.floor((time % 3600) / 60) < 10
              ? "0" + Math.floor((time % 3600) / 60)
              : Math.floor((time % 3600) / 60);
      let m =
          (time % 3600) % 60 < 10
              ? "0" + Math.floor((time % 3600) % 60)
              : Math.floor((time % 3600) % 60);
      return String(s) + String(f) + String(m);
    },
    back() {
      this.$router.back();
    },
    setNoTime(){
      this.notime = true;
    },
    selection(i) {
      if (this.active.indexOf(i) >= 0) {
        this.active.splice(this.active.indexOf(i), 1);
      } else {
        this.active.push(i);
      }
    },
    convertTimeToSeconds(timeString) {
      // 将时间字符串解析成小时、分钟和秒
      var hours = parseInt(timeString.slice(0, 2), 10);
      var minutes = parseInt(timeString.slice(2, 4), 10);
      var seconds = parseInt(timeString.slice(4), 10);

      // 计算总秒数
      return hours * 3600 + minutes * 60 + seconds;
    },
    read(i) {
      console.info(i);
      console.info(this.convertTimeToSeconds(this.dataInfo[i].schedule), this.dataInfo[i].schedule);
      this.loadTimerData();
      if (this.master) {
        if (this.timeFormat(this.playerNew.getPosition()) == "000000") {
          return;
        }
        if (this.$route.query.shiting) {
          this.pageIndex = i;
          this.playerNew = createCCH5Player({
            vid: this.dataInfo[i].vid,
            siteid: this.getSiteid(this.dataInfo[i].siteid, this.dataInfo[i].updatetime),
            customerId: 'jxjy2_' + this.$store.state.master.user.id,
            mediatype: 1,
            autoStart: "true",
            width: 880,
            height: 495,
            isShare: "false",
            banDrag: "false",
            progressbar_enable: 0,
            watchStartTime: this.convertTimeToSeconds(this.dataInfo[i].schedule),
            parentNode: "#playerContainer",
          });
          clearInterval(this.timer1);
          return;
        }
        api
            .postData(
                "student/saveRecord",
                {
                  comboId: this.$route.query.id,
                  coursewareId: this.dataInfo[this.pageIndex].id,
                  schedule: this.timeFormat(this.playerNew.getPosition()),
                  videoTimer: this.timeFormat(this.playerNew.getDuration()),
                },
                (err) => {
                  console.log(err);
                }
            )
            .then((res) => {
              // api.EventBus.$emit("loadTimeInfo");
              this.pageIndex = i;
              this.playerNew = createCCH5Player({
                vid: this.dataInfo[i].vid,
                siteid: this.getSiteid(this.dataInfo[i].siteid, this.dataInfo[i].updatetime),
                customerId: 'jxjy2_' + this.$store.state.master.user.id,
                mediatype: 1,
                autoStart: "true",
                width: 880,
                height: 495,
                isShare: "false",
                banDrag: "false",
                progressbar_enable: 0,
                watchStartTime: this.convertTimeToSeconds(this.dataInfo[i].schedule),
                parentNode: "#playerContainer",
              });

              clearInterval(this.timer1);

              this.saveTimeRecord();
            });
      } else {
        this.pageIndex = i;
        this.playerNew = createCCH5Player({
          vid: this.dataInfo[i].vid,
          siteid: this.getSiteid(this.dataInfo[i].siteid, this.dataInfo[i].updatetime),
          customerId: 'jxjy2_' + this.$store.state.master.user.id,
          mediatype: 1,
          autoStart: "true",
          width: 880,
          height: 495,
          isShare: "false",
          banDrag: "false",
          progressbar_enable: 0,
          watchStartTime: this.convertTimeToSeconds(this.dataInfo[i].schedule),
          parentNode: "#playerContainer",
        });
        clearInterval(this.timer1);
      }
    },
  },
  beforeDestroy() {
    if (this.master) {
      if (this.timeFormat(this.playerNew.getPosition()) == "000000") {
        return;
      }
      if (!this.shiting) {
        api
            .postData(
                "student/saveRecord",
                {
                  comboId: this.comboId,
                  coursewareId: this.dataInfo[this.pageIndex].id,
                  schedule: this.timeFormat(this.playerNew.getPosition()),
                  videoTimer: this.timeFormat(this.playerNew.getDuration()),
                },
                (err) => {
                  console.log(err);
                }
            )
            .then((res) => {
              // api.EventBus.$emit("loadTimeInfo");
            });
      }

      clearInterval(this.timer1);

      clearInterval(this.tTimer);
    }
    //跳转到其他页面，视频停止
  },
  watch: {},
};
</script>

<style lang="scss">
.CurriculumVideo {
  span.ccH5sp {
    display: none !important;
  }

  padding-bottom: 46px;

  .video-js .vjs-big-play-button {
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  #playerContainer {
    width: 880px;
    height: 495px;
  }

  &-time {
    height: 60px;
    background: #fff;
    display: flex;

    &-l {
      flex: 1;
      padding-left: 12px;
      display: flex;
      align-items: center;
    }

    &-btn {
      width: 100px;
      line-height: 60px;
      text-align: center;
      background: #cccccc;
      font-size: 14px;
      color: #fff;
    }

    &-font {
      color: #999;
      font-size: 14px;

      .s1 {
        color: #222222;
        margin-left: 22px;
      }

      .s2 {
        color: #37bc5f;
      }

      .s3 {
        color: #ec6941;
      }

      .s4 {
        color: #bfac8e;
      }
    }
  }

  &-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 100;
  }

  &-top {
    display: flex;
    align-items: center;

    &-l {
      flex: 1;
    }
  }

  &-back {
    width: 80px;
    height: 32px;
    line-height: 32px;
    background: rgba(34, 34, 34, 1);
    border-radius: 3px;
    text-align: center;
    cursor: pointer;
    color: #fff;
    font-size: 14px;
  }

  &-back:hover {
    background: rgba(34, 34, 34, 0.8);
  }

  &-alert {
    width: 700px;
    background: #fff;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: 3px;
    z-index: 2000;

    &-title {
      display: flex;
      padding: 18px 20px;
      align-items: center;
      justify-content: space-between;
      height: 50px;
      border-bottom: 1px solid #cccccc;

      .s1 {
        font-size: 16px;
        color: #161a21;
      }

      .s2 {
        color: #eb020c;
        font-size: 14px;
      }

      .s3 {
        font-weight: bold;
      }
    }

    &-bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-left: 20px;

      .ivu-input-wrapper {
        width: 200px;
      }

      .ivu-input {
        border: none;
      }
    }

    &-bar {
      display: flex;
      align-items: center;
    }

    &-btn {
      width: 120px;
      height: 50px;
      text-align: center;
      line-height: 50px;
      color: #fff;
      font-size: 14px;
      background: rgba(236, 105, 65, 1);
      cursor: pointer;
    }

    &-btn:hover {
      background: rgba(236, 105, 65, 0.8);
    }

    &-btn2 {
      font-size: 14px;
      color: #666666;
      margin-right: 46px;
      text-decoration: underline;
      cursor: pointer;
    }

    &-btn2:hover {
      color: #ec6941;
    }
  }

  &-alert2 {
    width: 200px;
    height: 50px;
    background: rgba(255, 255, 255, 1);
    border-radius: 3px;
    color: #ec6941;
    text-align: center;
    font-size: 14px;
    line-height: 50px;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  &-title {
    color: #161a21;
    font-size: 24px;
  }

  &-browse {
    color: #999999;
    font-size: 14px;
    margin-bottom: 10px;
    line-height: 1;
  }

  &-main {
    display: flex;
  }

  &-video {
    width: 880px;
    height: 495px;
  }

  &-list {
    flex: 1;
    background: #fafafa;

    .ivu-tabs {
      height: 355px;

      .ivu-tabs-tabpane {
        height: 285px;
        overflow-y: auto;
      }
    }
  }

  &-user {
    padding-top: 20px;
    padding-left: 30px;
    display: flex;
    height: 80px;
    background: #fff;

    &-img {
      width: 42px;
      height: 42px;
      border-radius: 50%;
      margin-right: 16px;
    }

    &-position {
      color: #999999;
      font-size: 14px;
    }

    &-name {
      color: #222222;
      font-size: 16px;
    }
  }

  &-catalog {
    padding-top: 22px;
    padding-left: 30px;

    &-title {
      color: #222222;
      font-weight: bold;
      font-size: 14px;
      margin-bottom: 30px;
    }
  }

  &-questions {
    padding: 0 20px;

    textarea.ivu-input {
      height: 144px;
    }

    &-btn {
      cursor: pointer;
      width: 80px;
      height: 36px;
      background: rgba(34, 34, 34, 1);
      border-radius: 3px;
      font-size: 14px;
      color: #ffffff;
      text-align: center;
      line-height: 36px;
      margin-top: 10px;
    }

    &-btn:hover {
      background: rgba(34, 34, 34, 0.8);
    }
  }

  &-subject {
    font-size: 16px;
    color: #161a21;
    padding: 28px 0 42px 28px;
  }

  &-answer {
    margin-left: 50px;
    display: flex;
    margin-bottom: 16px;
    align-items: center;
    cursor: pointer;

    span {
      width: 30px;
      height: 30px;
      border: 1px solid #161a21;
      line-height: 30px;
      text-align: center;
      border-radius: 50%;
      margin-right: 20px;
    }

    &-active {
      span {
        background: #ec6941;
        border-color: #ec6941;
        color: #fff;
      }
    }

    &-btn {
      width: 100px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      background: #ec6941;
      color: #fff;
      cursor: pointer;
      border-radius: 5px;
      margin-left: 50px;
      margin-top: 46px;
    }

    &-btn:hover {
      background: rgba(236, 105, 65, 0.8);
    }

    &-msg {
      color: #ec6941;
      font-size: 14px;
      margin-left: 50px;
      margin-top: 10px;
    }

    p {
      color: #161a21;
      font-size: 16px;
      flex: 1;
    }
  }

  &-active {
    background: #ec6941;
    cursor: pointer;
  }

  .ivu-tabs-nav {
    left: 60px;
  }

  .ivu-timeline {
    margin-left: 20px;
  }

  .ivu-tabs-nav .ivu-tabs-tab {
    font-size: 16px;
    color: #222;
    padding-top: 20px;
    padding-bottom: 10px;
    width: 100px;
    text-align: center;
  }

  .ivu-tabs-ink-bar {
    background-color: #222222;
  }

  .ivu-tabs-bar {
    border-top: 1px solid;
    border-color: #dddddd;
  }

  .ivu-timeline-item-head {
    border-color: #161a21;
  }

  .ivu-timeline-item-content {
    font-size: 14px;
    cursor: pointer;
  }

  .CurriculumVideo-future {
    .ivu-timeline-item-head {
      border-color: #999999;
      background-color: #999999;
    }

    .ivu-timeline-item-content {
      color: #999;
    }
  }

  .CurriculumVideo-now {
    .ivu-timeline-item-head {
      border-color: #ec6941;
      background-color: #ec6941;
    }

    .ivu-timeline-item-content {
      color: #ec6941;
    }
  }
}
</style>
